import { connect } from 'react-redux';

import { selectOptions } from 'src/redux/basket/selectors';
import { actions as basketActions } from 'src/redux/basket/slice';
import type { ReduxApplicationState } from 'src/redux/combinedReducer';
import { selectProduct } from 'src/redux/product/selectors';
import type { AppThunkDispatch } from 'src/redux/store';
import { isOutOfStock } from 'src/utils/inventoryStatus';
import type { ProductOptionsDispatchProps, ProductOptionsStateProps } from './ProductOptions';
import { ProductOptions } from './ProductOptions';

const mapDispatchToProps = (dispatch: AppThunkDispatch): ProductOptionsDispatchProps => {
  return {
    onChangeQuantity: ({ quantity, valid }) => {
      dispatch(basketActions.changeQuantity({ isValid: valid, quantity }));
    },
  };
};

const mapStateToProps = (state: ReduxApplicationState): ProductOptionsStateProps => {
  const product = selectProduct(state);

  return {
    inStock: !isOutOfStock(product.inventoryStatus),
    quantity: state.basket.quantity,
    showPriceBreakdown: Boolean(selectOptions(state).length),
  };
};

export const ProductOptionsContainer = connect(mapStateToProps, mapDispatchToProps)(ProductOptions);
